// src/modules/app-views/_apps/appmulti/coupons/pages/Init/actions/menuButton.js
import { dropdownParameters } from 'layouts/Pages/PageHeader/dropdownMenus';

const couponsInitMenuButton = () => {
  return {
    action: 'dropdownMenu',
    dropdownItems: [{ ...dropdownParameters, onClick: () => {} }],
  };
};

export default couponsInitMenuButton;
